import { useState } from "react";
import ProductCard from "./ProductCard";
import styles from "./ProductTree.module.css";
import EditItem from "./EditItem";
import AddProductModal from "./AddProductModal";
import AddChildModal from "./AddChildModal";

const ProductTree = ({ allProducts, refetchAllProducts }) => {
  const [currentParentId, setCurrentParentId] = useState(null);
  const [currentProductData, setCurrentProductData] = useState(null);
  const [editItem, setEditItem] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isAddChildModalOpen, setIsAddChildModalOpen] = useState(false);

  const rootProducts = allProducts?.filter(
    (product) => product.parent_id === null
  );

  const childrenProducts =
    currentProductData?.children_ids?.map((id) =>
      allProducts.find((p) => p.id === id)
    ) || [];

  const goBack = () => {
    const currentProduct = allProducts?.find((p) => p.id === currentParentId);
    setCurrentParentId(currentProduct?.parent_id || null);
    setCurrentProductData(
      currentProduct
        ? allProducts.find((p) => p.id === currentProduct.parent_id)
        : null
    );
  };

  const productCardHandler = (product) => {
    setCurrentParentId(product.id);
    setCurrentProductData(product);
  };

  const handleModalClose = () => {
    setEditItem(null);
    setIsModalOpen(false);
  };

  const handleEditClick = () => {
    setEditItem(currentProductData);
    setIsModalOpen(true);
  };

  const handleAddProduct = () => {
    setIsAddModalOpen(true);
  };

  const handleAddChild = () => {
    setIsAddChildModalOpen(true);
  };

  return (
    <div className={styles.container}>
      {currentParentId !== null && currentProductData && (
        <div className={styles.buttonContainer}>
          <button onClick={goBack} className={styles.backButton}>
            ← Back
          </button>

          <div className={styles.rightSideButtons}>
            <button onClick={handleAddChild}>Add Child</button>
            <button onClick={handleEditClick} className={styles.editButton}>
              Edit
            </button>
          </div>
        </div>
      )}
      {currentParentId === null && (
        <div className={styles.addButtonContainer}>
          <button onClick={handleAddProduct} className={styles.addProductModal}>
            Add Product
          </button>
        </div>
      )}

      {/* Detail view of current product */}
      {currentProductData && (
        <div className={styles.detailCard}>
          <img
            src={currentProductData?.img_url}
            alt={currentProductData?.app_name}
            className={styles.detailImage}
          />
          <div className={styles.detailContent}>
            <h2>{currentProductData?.app_name}</h2>
            <p>{currentProductData?.description}</p>
            {Array.isArray(currentProductData.features) &&
              currentProductData.features.length > 0 && (
                <ul>
                  {currentProductData.features.map((f, i) => (
                    <li key={i}>{f}</li>
                  ))}
                </ul>
              )}
          </div>
        </div>
      )}

      <div className={styles.gridLayout}>
        {(currentProductData
          ? childrenProducts?.filter(Boolean)
          : rootProducts
        ).map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            onClick={() => productCardHandler(product)}
          />
        ))}
      </div>

      {/* Add Modal */}
      {isAddModalOpen && (
        <AddProductModal
          onClose={() => setIsAddModalOpen(false)}
          refetchAllProducts={refetchAllProducts}
        />
      )}
      {/* Edit Modal */}
      {isModalOpen && editItem && (
        <EditItem
          editItem={editItem}
          onClose={handleModalClose}
          refetchAllProducts={refetchAllProducts}
        />
      )}

      {isAddChildModalOpen && (
        <AddChildModal
          parentId={currentParentId}
          parentData={currentProductData}
          onClose={() => setIsAddChildModalOpen(false)}
          refetchAllProducts={refetchAllProducts}
        />
      )}
    </div>
  );
};

export default ProductTree;
